import Vue from 'vue'

import {
  Dropdown,
  Submenu,
  Menu,
  MenuItem,
  Table,
  TableColumn,
  Scrollbar,
  DropdownMenu,
  DropdownItem,
  Message,
  MessageBox,
  Button,
  Input,
  Pagination,
  Form,
  Row,
  Col,
  FormItem,
  Select,
  Switch,
  Tag,
  Tree,
  Option,
  Popover,
  Container,
  Aside,
  Main,
  Header,
  Loading,
  Tooltip,
  DatePicker,
  Checkbox,
  Dialog,
  RadioGroup,
  RadioButton,
  TimePicker,
  Radio,
  Progress
} from 'element-ui'

Vue.use(Progress)
Vue.use(Radio)
Vue.use(TimePicker)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Dialog)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Tooltip)
Vue.use(Header)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Popover)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(Submenu)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Scrollbar)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Button)
Vue.use(Input)
Vue.use(Pagination)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Select)
Vue.use(Switch)
Vue.use(Tag)
Vue.use(Tree)

Vue.prototype.$message = function(msg) {
  Message({
    message: msg,
    customClass: 'zIndex9999999'
  })
}

Vue.prototype.$message.success = function(msg) {
  Message.success({
    message: msg,
    customClass: 'zIndex9999999'
  })
}

Vue.prototype.$message.error = function(msg) {
  Message.error({
    message: msg,
    customClass: 'zIndex9999999'
  })
}

Vue.prototype.$message.warning = function(msg) {
  Message.warning({
    message: msg,
    customClass: 'zIndex9999999'
  })
}

Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$loading = Loading
Vue.prototype.$element = 30000
